/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduleUpdateScheduleParam model module.
 * @module model/ScheduleUpdateScheduleParam
 * @version 1.0
 */
class ScheduleUpdateScheduleParam {
    /**
     * Constructs a new <code>ScheduleUpdateScheduleParam</code>.
     * @alias module:model/ScheduleUpdateScheduleParam
     */
    constructor() { 
        
        ScheduleUpdateScheduleParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduleUpdateScheduleParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduleUpdateScheduleParam} obj Optional instance to populate.
     * @return {module:model/ScheduleUpdateScheduleParam} The populated <code>ScheduleUpdateScheduleParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduleUpdateScheduleParam();

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('orgId')) {
                obj['orgId'] = ApiClient.convertToType(data['orgId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} date
 */
ScheduleUpdateScheduleParam.prototype['date'] = undefined;

/**
 * @member {Number} orgId
 */
ScheduleUpdateScheduleParam.prototype['orgId'] = undefined;

/**
 * @member {Number} userId
 */
ScheduleUpdateScheduleParam.prototype['userId'] = undefined;






export default ScheduleUpdateScheduleParam;

